<template>
    <v-dialog  v-model="dialog" scrollable max-height="auto" :max-width="($vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm') ? '90%' : '50%'" persistent >
        <v-card 
                outlined
                height="80vh"
                prominent
                class="mx-auto elevation-0 overflow-y-auto"
            >

            <v-card-title class="ma-0 pa-0">
                <v-app-bar dense height="45" class='mb-0 elevation-1'>
                        
                    <v-toolbar-title class="subtitle-1">
                            <span class="mb-0">
                                ({{ selected.length }}) Professor(es) selecionado(s) <strong v-if="selected.length > maxSelected" class="red--text">Máximo {{ maxSelected }} professores</strong>
                            </span>
                        </v-toolbar-title>

                        <v-spacer></v-spacer>

                         <emc-button-icon icon='mdi-refresh' text="Atualizar" color="success" :loading="loadingRefresh" @click.prevent.stop="getItems(true)" />

                        <v-tooltip v-if="totalPages > 1" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="selected.length === 0" icon @click.native="clearFilter()" v-bind="attrs" v-on="on">
                                    <v-icon color="primary lighten-2">mdi-playlist-remove</v-icon>
                                </v-btn>
                            </template>
                            <span>Limpar todos items selecionados</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="disableButton" :loading="loadingSaving" icon @click.prevent.stop="generate()" v-bind="attrs" v-on="on">
                                    <v-icon color="amber darken-1">mdi-flash-outline</v-icon>
                                </v-btn>
                            </template>
                        <span>Gerar Termos</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click.native="dialog = false" v-bind="attrs" v-on="on">
                                <v-icon color="red lighten-2">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Fechar</span>
                    </v-tooltip>
                </v-app-bar>
            </v-card-title>
            
            <v-card-text  class="pt-2">
                <v-container>
                     <v-row class="mb-0">
                        <v-col cols="12" sm="6">
                            <sys-select-term
                                :model.sync="term_id"
                                label="Termo"
                                dense
                                outlined
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <sys-select-brand
                                :model.sync="brandIds"
                                :educationalGroupId="educationalGroupId"
                                label="Marca"
                                dense
                                outlined
                                clearable
                                multiple
                                :return-object="false"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="mb-0">
                        <v-col cols="12" sm="6">
                            <sys-select-campus
                                :model.sync="campusIds"
                                :brandId="brandIdForCampus"
                                :educationalGroupId="educationalGroupId"
                                label="Campus"
                                dense
                                outlined
                                clearable
                                multiple
                                :return-object="false"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <sys-select-course
                                :model.sync="courseIds"
                                :campusId="campusIdsForCourse"
                                label="Curso"
                                dense
                                outlined
                                clearable
                                multiple
                                :return-object="false"
                                filter
                            />
                        </v-col>
                    </v-row>
                    <v-row class="mb-0">
                        <v-col cols="12" sm="6">
                            <SelectVariationStatus
                                v-model="workLoadVariationStatus"
                                label="Status de Variação"
                                outlined
                                dense
                                load-data
                                clearable
                            />
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col cols="12" sm="12" class="pt-0">
                            <v-text-field
                                v-model="search"
                                label="Buscar professor por nome"
                                prepend-inner-icon="mdi-magnify"
                                clearable
                                dense
                                outlined
                                hide-details
                                class="mb-2"
                                @input="onSearchInput"
                            />
                            <v-list dense class="pa-0 ma-0">
                                    <v-list-item-group
                                        v-model="selectedTeacher"
                                        color="primary"
                                    >
                                            <v-list-item
                                                ripple
                                                @mousedown.prevent
                                                @click="toggle"
                                            >
                                                <v-list-item-action>
                                                    <v-icon v-if="items.length" :color="selected.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Selecionar todos
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                
                                                <v-progress-linear
                                                    v-if="loading"
                                                    indeterminate
                                                    color='yellow darken-2'
                                                />

                                                <emc-util-scroll height="40vh">
                                                    <v-list-item
                                                        v-for="(item, index) in items"
                                                        :key="index"
                                                        @mousedown.prevent
                                                        @click="selectTeacher(index)"
                                                        >
                                                        <v-list-item-icon>
                                                            <v-icon :color="isCheckedTeacher(index) ? 'indigo darken-4' : ''" v-text="isCheckedTeacher(index) ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'" />
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title v-text="item.name"></v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </emc-util-scroll>
                                    </v-list-item-group>
                                </v-list>
                        </v-col>
                    </v-row>
                    
                </v-container>
            </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row align="center" class="mb-2">
                            <v-col cols="12" sm="6" class="d-flex align-center">
                                <v-btn
                                    color="amber darken-1"
                                    :disabled="disableButton"
                                    :loading="loadingSaving"
                                    @click.prevent.stop="generate()"
                                    depressed
                                >
                                    <v-icon left>mdi-flash-outline</v-icon>
                                    Gerar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" class="d-flex justify-end">
                                    <v-pagination
                                    v-model="page"
                                    class="my-0"
                                    @input="pagination()"
                                    :length="totalPages"
                                    ></v-pagination>
                            </v-col>
                        </v-row>
                    </v-container>
            </v-card-actions>
            
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import SelectVariationStatus from '@/domains/teacher/indicator/components/SelectVariationStatus.vue'

export default {
    name: "SysTermGenerate",
    data: (vm) => ({
        dialog: false,
        loading: false,
        loadingRefresh: false,
        loadingSaving: false,
        page: 1,
        maxSelected: 200,
        totalPages: 0,
        term_id: null,
        items: [],
        selected: [],
        selectedCurrent: [],
        selectedTeacher: null,
        workLoadVariationStatus: null,
        educationalGroupId: null,
        brandIds: [],
        campusIds: [],
        courseIds: [],
        search: '',
        searchTimeout: null,
    }),
    components: {
        SelectVariationStatus,
    },
    computed: {
        ...mapState('auth', ['acesso', 'user']),
        
        brandIdForCampus() {
            const first = this.brandIds && this.brandIds[0];
            return first != null ? (typeof first === 'object' && first.id != null ? first.id : first) : null;
        },

        campusIdsForCourse() {
            const ids = Array.isArray(this.campusIds) ? this.campusIds : [];
            return ids.map(c => (typeof c === 'object' && c != null && c.id != null) ? c.id : c).filter(Boolean);
        },

        disableButton (){

            return !this.selected.length || this.selected.length > this.maxSelected || !this.term_id;

        },

        likesAllTeacher () {

            return this.selectedCurrent.length === this.items.length
        },

        likesSomeTeacher () {
            return this.selectedCurrent.length > 0 && !this.likesAllTeacher
        },

        icon () {
            if (this.likesAllTeacher) return 'mdi-close-box'
            if (this.likesSomeTeacher) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },

    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },

    watch: {

        dialog(val) {
            this.$emit('update:show', val);
            if (!val) {
                this.resetModal();
            }
        },

        show(val) {
            this.dialog = val;
            if (val) {
                if (this.acesso && this.acesso.grupo && this.acesso.grupo.id) {
                    this.educationalGroupId = this.acesso.grupo.id;
                }
                if (this.items.length === 0) {
                    this.getItems();
                }
            }
        },

        // Watchers para recarregar lista ao mudar filtros de segmentação (apenas quando modal aberto)
        educationalGroupId() {
            if (this.dialog) this.resetAndReload();
        },

        brandIds() {
            if (this.dialog) this.resetAndReload();
        },

        campusIds() {
            if (this.dialog) this.resetAndReload();
        },

        courseIds() {
            if (this.dialog) this.resetAndReload();
        },

        workLoadVariationStatus() {
            if (this.dialog) this.resetAndReload();
        },

    },
    methods: {
        ...mapActions('teacher', ['ActionFindTeachers']),
        ...mapActions('term', ['ActionUpdateTermSignatureGenerate']),

        resetModal() {
            this.page = 1;
            this.term_id = null;
            this.items = [];
            this.selected = [];
            this.selectedCurrent = [];
            this.selectedTeacher = null;
            this.workLoadVariationStatus = null;
            this.educationalGroupId = this.acesso?.grupo?.id || null;
            this.brandIds = [];
            this.campusIds = [];
            this.courseIds = [];
            this.search = '';
            this.totalPages = 0;
            this.loading = false;
            this.loadingRefresh = false;
            this.loadingSaving = false;
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = null;
            }
        },

        resetAndReload() {
            this.page = 1;
            this.selected = [];
            this.selectedCurrent = [];
            this.getItems();
        },

        onSearchInput() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => {
                this.page = 1;
                this.getItems();
            }, 400);
        },
        
        async getItems(loadingRefresh = false) {

            this.loadingRefresh = loadingRefresh;
            this.loading = true;
            this.loadingSaving = false;
            this.selectedCurrent = [];
            this.selected = [];

            let payload = {
                column_order: 'name',
                direction: 'asc',
                page: this.page,
                per_page: this.maxSelected,
                search: this.search || '',
                find_columns: {
                    active: 1,
                }
            }

            // Construir filter_relations com todos os critérios de segmentação
            let filterRelations = [];

            // Helper: extrai IDs de array (pode vir como objetos {id, name} ou como IDs)
            const toIds = (val) => {
                if (!val) return [];
                const arr = Array.isArray(val) ? val : [val];
                return arr.map(v => (typeof v === 'object' && v != null && v.id != null) ? v.id : v).filter(v => v != null && v !== '');
            };

            const brandIdsStr = toIds(this.brandIds).join(',');
            const campusIdsStr = toIds(this.campusIds).join(',');
            const courseIdsStr = toIds(this.courseIds).join(',');

            // Filtro por Marca (via relação direta brands)
            if (brandIdsStr) {
                filterRelations.push({
                    name: 'brands',
                    key: 'brands.id',
                    value: brandIdsStr,
                    clause: 'whereIn'
                });
            }

            // Filtro por Campus (via relação direta campuses)
            if (campusIdsStr) {
                filterRelations.push({
                    name: 'campuses',
                    key: 'campuses.id',
                    value: campusIdsStr,
                    clause: 'whereIn'
                });
            }

            // Filtro por Mantenedora (via campus.educational_group_id)
            if (this.educationalGroupId) {
                filterRelations.push({
                    name: 'campuses',
                    key: 'campuses.educational_group_id',
                    value: this.educationalGroupId,
                    clause: 'where'
                });
            }

            // Filtro por Curso (via contracts.courses)
            if (courseIdsStr) {
                filterRelations.push({
                    name: 'contracts',
                    innerRelations: [{
                        name: 'courses',
                        key: 'courses.id',
                        value: courseIdsStr,
                        clause: 'whereIn'
                    }]
                });
            }

            // Filtro por Status de Variação de Carga
            if (this.workLoadVariationStatus) {
                filterRelations.push({
                    name: 'indicators',
                    key: 'work_load_variation_status_id',
                    value: this.workLoadVariationStatus
                });
            }

            // Adicionar filter_relations ao payload apenas se houver filtros
            if (filterRelations.length) {
                payload.filter_relations = filterRelations;
            }

            try {
                const res = await this.ActionFindTeachers(payload);
                this.totalPages = res.meta.last_page;
                this.items = res.data || [];

                this.items.forEach(item => {
                    if (this.selected.includes(item.id)) {
                        this.selectedCurrent.push(item.id);
                    }
                });
            } catch (err) {
                this.items = [];
                this.totalPages = 0;
                if (process.env.NODE_ENV !== 'production') {
                    console.error('[SysTermGenerate] Erro ao carregar docentes:', err);
                }
            } finally {
                this.loading = false;
                this.loadingRefresh = false;
            }
        },

        pagination(){

            this.getItems();

        },


        generate(){

            if(!this.term_id){
                return;
            }
            
            let payload = {
                teacher_ids:    this.selected,
                term_id:        this.term_id,
            };

            this.loadingSaving = true;

            this.ActionUpdateTermSignatureGenerate(payload)
                .then((res) => {
                    this.$emit('onCompleted');
                })
                .finally(() => {
                    this.loadingSaving = false;
                });

            
       },

       toggle () {
            
            this.$nextTick(() => {
                
                if (this.likesAllTeacher) {
                    
                    this.selectedCurrent.forEach(id => {
                        
                        if(this.selected.includes(id)){
                            this.selected.splice(this.selected.indexOf(id), 1);
                        }
                    });
                   
                    this.selectedCurrent = [];

                }else{
                    for (let index = 0; index < this.items.length; index++) {
                        
                        let id = this.items[index]['id'];
                        
                        if(!this.selected.includes(id)){
                            this.selected.push(id);
                        }

                        if(!this.selectedCurrent.includes(id)){
                            this.selectedCurrent.push(id);
                        }
                   }
                }
                
            })
        },

        clearFilter(){
            this.selected = [];
            this.selectedCurrent = [];
        },

        isCheckedTeacher(index){
            
            let id = this.items[index]['id'];
            
            return this.selected.includes(id);
        },

        selectTeacher(index){
            
            let id = this.items[index]['id'];
            
            if(this.selected.includes(id)){
                this.selected.splice(this.selected.indexOf(id), 1);
            }else{
                this.selected.push(id);
            }

            if(this.selectedCurrent.includes(id)){
                this.selectedCurrent.splice(this.selectedCurrent.indexOf(id), 1);
            }else{
                this.selectedCurrent.push(id);
            }
            
        },

        

    }
}
</script>